import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type { LeasesRenewalsFilter } from './leasesRenewalsRepository';
import type { LeaseRenewalOfferPaginationDto } from '~/swagger/portal/Api';

const BASE_URL = '/api/leases/renewals';

export class RenewalsRepository extends BaseRestRepository {
  public async getRenewalOffers(params?: LeasesRenewalsFilter): Promise<LeaseRenewalOfferPaginationDto> {
    const url = urlWithQuery(BASE_URL, params);
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }
}
